import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { ClassesService } from 'src/app/services/classes.service';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { Class } from 'src/app/models/class.model';
import { firstValueFrom } from 'rxjs';
import { MatSidenav } from '@angular/material/sidenav';
import { ModifyClassComponent } from '../classes/modify-class/modify-class.component';
import * as globals from '../globals';
import { LoggingService } from '../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-trainings',
  templateUrl: './trainings.component.html',
  styleUrls: ['./trainings.component.scss']
})

export class TrainingsComponent implements OnInit {

  constructor(
    public media: MediaObserver,
    private classesService: ClassesService,
    private logger: LoggingService
    ) {  }

  ngOnInit(): void {
    this.retrieveData();
    
    setTimeout(() => {
      this.updateInitialTabClass();
    }, 
      5000);
    this.isContributor = ([`${globals.TC}:${globals.trainingadmin}`, `${globals.TC}:${globals.trainer}`].includes(localStorage.getItem(globals.POLICIES)));
  }

  tabChanged(event: MatTabChangeEvent) {
    this.selectedTabIndex = event.index;
    this.retrieveData();
    this.selectedClass = this.classes[this.selectedTabIndex];
  }

  tabDelete(event) {    
    const classValue = this.classes[this.selectedTabIndex];

    this.classesService.deleteClass(classValue.id).subscribe({
      next: (data) => {
        this.logger.logEvent('Class Deleted', {classId: classValue.id});
        this.refreshList();
      },
      error: (e) => {
        this.logger.logException(e);
        console.error(e);
      }
    });
  }

  classSaved = (response) => this.refreshList(true);

  classModified = (response) => this.refreshList(true, true);

  updateInitialTabClass() {
    if(this.classes?.length > 0) {
      this.selectedClass = this.classes[0];
    }
    else {
      setTimeout(() => this.updateInitialTabClass(), 5000);
    }
  }

  loadingSpinner = (value: boolean) => this.connectCreating = value;

  refreshList(isNew: boolean = false, isAdd: boolean = false): void {
    this.retrieveData(isNew, isAdd);
  }

  async retrieveData(isNew: boolean = false, isAdd: boolean = false) {
    this.loadingSpinner(true);
    try {
      if(isNew || this.classes === undefined) {
        const classes = await firstValueFrom(this.classesService.getClasses());
        this.classes = classes;
        this.classesLength = classes.length;
      }

      if(this.classesLength > 0) {
        this.class_id = this.classes[this.selectedTabIndex].id;
        this.isDataHubEnabled = this.classes[this.selectedTabIndex].services.includes('DataHub');
        if(isNew && !isAdd) { this.selectedTabIndex = this.classesLength; };
      }

      this.loadingSpinner(false);
    }
    catch {
      this.loadingSpinner(false);
    }
  }

  classCancelled = ($response) => this.refreshList(true, true);

  isMobile = () => window.matchMedia('(max-width: 840px)').matches;
  
  private modifyClass(classValue: Class) {
    this.selectedClass = classValue;
    this.modifyClassComponent.retrieveCreateServices(true);
    this.sidenaveditclass.open();
  }

  selectedTabIndex = 0;
  classesLength = 0;
  class_id = 0;
  isContributor: boolean;
  connectCreating: boolean;
  showChild: boolean = true;
  classes?: Class[];
  selectedClass: Class = {} as Class;
  isDataHubEnabled: boolean = false;
  
  @Input() class: string;
  @ViewChild('tabGroup') tabGroup: MatTabGroup;
  @ViewChild('sidenaveditclass') sidenaveditclass: MatSidenav;
  @ViewChild(ModifyClassComponent) modifyClassComponent: ModifyClassComponent;
}
